import React, { useContext, useEffect, useReducer, useState } from "react";
import ReporteContext from "./reporteContext";
import ReporteReducer from "./reporteReducer";
import jsPDF from "jspdf";
import proyectoContext from "../proyectos/proyectoContext";
import clienteAxios from "../../config/axios";
import swal from "sweetalert";
import OpenSansRegular from "../../assets/fonts/OpenSans-Regular-normal"; // no quitar
import OpenSansSemiBold from "../../assets/fonts/OpenSans-SemiBold-normal"; // no quitar
import OpenSansBold from "../../assets/fonts/OpenSans-Bold-normal"; // no quitar
import { ACTIVAR_DESCARGA_ORDEN, DESACTIVAR_DESCARGA_ORDEN } from "../../types";
import pdfMake, { fonts } from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts.js";

pdfMake.vfs = vfsFonts;



const ReporteState = (props) => {
  const initialState = {
    stOrdenCompraPDF: null,
    activarDescargaOrden: false,
    stPresupuestoPDF: null,
  };

  const [state, dispatch] = useReducer(ReporteReducer, initialState);

  const ProyectoContext = useContext(proyectoContext);
  const {
    modulosEvento,
    cleanStatusModulosEvento,
    stGenerarPresupuesto,
    cleanGenerarPresupuesto,
    fndesactivarOrdencompra,
    stActivarOrdenCompra,
    datosOrden,
    statusModuloOrden,
    modulosProveedorEvento,
    cleanStatusModulosOrden,
  } = ProyectoContext;

  const [idCliente, setIdCliente] = useState(null);
  const [datosCliente, setDatosCliente] = useState([]);
  const [dataEvento, setDataEvento] = useState([]);
  const [dataEventoOrden, setDataEventOrden] = useState([]);
  const [allDataOrdenPDF, setAllDataOrdenPDF] = useState([]);

  var modEnEvento = modulosEvento !== null && modulosEvento.data;
  var statusModEnEvento = modulosEvento !== null && modulosEvento.status;

  const usuario = JSON.parse(localStorage.getItem("usuario"));

  useEffect(() => {
    // PRESUPUESTO
    if (
      statusModEnEvento === 200 &&
      idCliente !== null &&
      stGenerarPresupuesto
    ) {
      const fetchData = async () => {
        var cliente_evento = await clienteAxios.get("api/cliente/" + idCliente);
        setDatosCliente(cliente_evento);
      };
      fetchData();
    }

    if (
      statusModEnEvento === 200 &&
      datosCliente.length !== 0 &&
      stGenerarPresupuesto
    ) {
      fnGenerarPresupuesto();
      cleanStatusModulosEvento();
      cleanGenerarPresupuesto();
    }
    // FIN PRESUPUESTO
    // ORDEN
    if (
      statusModuloOrden === 200 &&
      datosOrden.status === 200 &&
      stActivarOrdenCompra === true
    ) {
      cleanStatusModulosOrden();
      setAllDataOrdenPDF({
        dataEvento: dataEventoOrden.evento,
        dataProveedor: dataEventoOrden.proveedor,
        dataOrden: datosOrden.data,
        dataModulosOrden: modulosProveedorEvento,
      });
    }

    if (Object.keys(allDataOrdenPDF).length > 0 && stActivarOrdenCompra) {
      fnOrdenCompraPDF();
      setAllDataOrdenPDF([]);
      fndesactivarOrdencompra();
    }
    // FIN ORDEN
  }, [
    stActivarOrdenCompra,
    allDataOrdenPDF,
    modulosEvento,
    modEnEvento,
    datosOrden,
    statusModEnEvento,
    datosCliente,
    stGenerarPresupuesto,
    state.activarDescargaOrden,
    dataEventoOrden,
    modulosProveedorEvento,
    statusModuloOrden,
  ]);

  const fnActivarInicioPDFOrden = () => {
    dispatch({
      type: ACTIVAR_DESCARGA_ORDEN,
    });
  };

  const fnDesactivarInicioPDFOrden = () => {
    dispatch({
      type: DESACTIVAR_DESCARGA_ORDEN,
    });
  };

  const toBase64 = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  const normalizarMontoEntero = (valor) => {
    if (valor === null || valor === undefined || valor === "") return 0;

    if (typeof valor === "number") {
      return Number.isFinite(valor) ? Math.trunc(valor) : 0;
    }

    let limpio = String(valor).replace(/[^0-9,.-]/g, "").trim();

    // Soporta montos guardados/mostrados en formato chileno: 600.000,38 o 220.000
    if (limpio.includes(",")) {
      limpio = limpio.replace(/\./g, "").replace(",", ".");
    } else if (/^-?\d{1,3}(\.\d{3})+$/.test(limpio)) {
      limpio = limpio.replace(/\./g, "");
    }

    const numero = Number(limpio);
    if (!Number.isFinite(numero)) return 0;
    return Math.trunc(numero);
  };

  const formatearMontoEntero = (valor) =>
    new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(normalizarMontoEntero(valor));

  const colorSeguro = (valor, fallback) => {
    const color = String(valor || "").trim();
    return /^#[0-9a-fA-F]{6}$/.test(color) ? color : fallback;
  };

  const textoSeguro = (valor, fallback = "") => {
    const texto = valor === null || valor === undefined ? "" : String(valor).trim();
    return texto || fallback;
  };

  const obtenerNumeroPresupuesto = (evento = {}) => {
    const numero = evento.presupuesto_numero || evento.presupuestoNumero || evento.numeroPresupuesto;
    if (numero !== null && numero !== undefined && numero !== "") return numero;
    return evento.id ? evento.id + 100 : "";
  };

  const normalizarBranding = (data = {}) => {
    const tenant = (usuario && usuario.tenant) || {};
    const nombre = textoSeguro(data.nombre, tenant.nombre || "Empresa");
    const razonSocial = textoSeguro(data.razonSocial || data.razon_social, nombre);
    const email = textoSeguro(data.email_contacto || data.emailContacto, tenant.email_contacto || "");
    const telefono = textoSeguro(data.telefono, tenant.telefono || "");
    const web = textoSeguro(data.presupuesto_web || data.web, "");
    const footer = textoSeguro(data.presupuesto_footer_text, [telefono, email, web].filter(Boolean).join("  ·  "));

    return {
      nombre,
      razonSocial,
      rut: textoSeguro(data.rut, ""),
      email,
      telefono,
      direccion: textoSeguro(data.direccion, ""),
      giro: textoSeguro(data.presupuesto_giro || data.giro, ""),
      ciudad: textoSeguro(data.presupuesto_ciudad || data.ciudad, ""),
      web,
      footerText: footer,
      logoDataUrl: data.logoPdfDataUrl || data.logoDataURL || null,
      logoUrl: data.logo_pdf_url || data.logoPdfUrl || data.logo_url || data.logoUrl || "",
      colorPrimario: colorSeguro(data.color_primario || data.colorPrimario, "#243356"),
      colorSecundario: colorSeguro(data.color_secundario || data.colorSecundario, "#66ABCB"),
    };
  };

  const cargarBrandingPDF = async () => {
    try {
      const respuesta = await clienteAxios.get("/api/tenant/branding");
      const branding = normalizarBranding(respuesta.data || {});
      if (!branding.logoDataUrl && branding.logoUrl) {
        try {
          branding.logoDataUrl = await toBase64(branding.logoUrl);
        } catch (error) {
          // Si la URL externa no permite CORS, el PDF sigue generándose con nombre de empresa.
        }
      }
      return branding;
    } catch (error) {
      return normalizarBranding({});
    }
  };

  const bloqueEmpresaPDF = (branding, styleName) => ([
    {
      width: "*",
      stack: [
        { text: [{ text: "Razón Social: ", bold: true }, branding.razonSocial], style: styleName },
        { text: [{ text: "Mail: ", bold: true }, branding.email], style: styleName },
        { text: [{ text: "Dirección: ", bold: true }, branding.direccion], style: styleName },
        { text: branding.ciudad, style: styleName },
      ].filter((item) => {
        if (Array.isArray(item.text)) return item.text[1];
        return item.text;
      }),
    },
    {
      width: 160,
      stack: [
        { text: [{ text: "Rut: ", bold: true }, branding.rut], alignment: "left", style: styleName },
        { text: [{ text: "Giro: ", bold: true }, branding.giro], alignment: "left", style: styleName },
        { text: [{ text: "Fono: ", bold: true }, branding.telefono], alignment: "left", style: styleName },
        { text: [{ text: "Web: ", bold: true }, branding.web], alignment: "left", style: styleName },
      ].filter((item) => Array.isArray(item.text) ? item.text[1] : item.text),
    },
  ]);

  const crearHeaderPDF = ({ branding, titulo, numero, fechaTexto, pageWidth, leftMargin, rightMargin }) => {
    const logoONombre = branding.logoDataUrl
      ? { image: branding.logoDataUrl, width: 128, margin: [0, 12, 0, 0] }
      : { text: branding.nombre, bold: true, fontSize: 18, color: branding.colorPrimario, margin: [0, 22, 0, 0] };

    return [
      {
        canvas: [
          { type: "rect", x: 0, y: 0, w: pageWidth, h: 8, color: branding.colorPrimario },
          { type: "line", x1: leftMargin, y1: 74, x2: pageWidth - rightMargin, y2: 74, lineWidth: 2, lineColor: branding.colorSecundario },
        ],
        absolutePosition: { x: 0, y: 0 },
      },
      {
        columns: [
          { width: 180, stack: [logoONombre] },
          { width: "*", text: "" },
          {
            width: 190,
            stack: [
              fechaTexto ? { text: fechaTexto, fontSize: 10, alignment: "right", margin: [0, 12, 0, 0] } : null,
              { text: titulo, bold: true, fontSize: 12, color: branding.colorPrimario, alignment: "right", margin: [0, fechaTexto ? 4 : 22, 0, 0] },
              { text: `N° ${numero}`, bold: true, fontSize: 18, color: branding.colorSecundario, alignment: "right" },
            ].filter(Boolean),
          },
        ],
        margin: [leftMargin, 0, rightMargin, 0],
      },
    ];
  };

  const crearFooterPDF = ({ branding, pageWidth, leftMargin, rightMargin }) => (currentPage, pageCount) => ({
    stack: [
      { canvas: [{ type: "line", x1: leftMargin, y1: 0, x2: pageWidth - rightMargin, y2: 0, lineWidth: 2, lineColor: branding.colorSecundario }] },
      {
        columns: [
          { width: "*", text: branding.footerText || branding.razonSocial, fontSize: 8, color: "#334155" },
          { width: 90, text: `Página ${currentPage} de ${pageCount}`, fontSize: 8, alignment: "right", color: "#64748b" },
        ],
        margin: [leftMargin, 8, rightMargin, 0],
      },
    ],
  });

  const calcularTotalNetoDesdeModulos = (modulos = []) => {
    if (!Array.isArray(modulos) || modulos.length === 0) return 0;

    return modulos.reduce((total, modulo) => {
      const valorModulo = normalizarMontoEntero(modulo && modulo.valor);
      const cantidadModulo = Number(modulo && modulo.cantidad) || 0;
      return total + normalizarMontoEntero(valorModulo * cantidadModulo);
    }, 0);
  };

  const obtenerTotalNetoPresupuesto = (evento, modulos = []) => {
    if (Array.isArray(modulos) && modulos.length > 0) {
      return calcularTotalNetoDesdeModulos(modulos);
    }

    return normalizarMontoEntero(evento && evento.totalCobrado);
  };

  const fnORdenPDF = (data) => {
    swal({
      title:
        "Sí existe una orden de compra asociada al proveedor, su reporte se descargará en breve",
      icon: "success",
      dangerMode: true,
    });
    setDataEventOrden({
      proveedor: data.data.proveedor,
      evento: data.data.evento,
    });
  };

  const fnOrdenCompraPDF = async () => {
  // Márgenes estándar carta (en puntos, donde 72 puntos = 1 pulgada)
  const leftMargin = 60, rightMargin = 60, topMargin = 95, bottomMargin = 80;
  const pageWidth = 612; // Ancho estándar de una página Carta US en puntos
  const usableWidth = pageWidth - leftMargin - rightMargin; // Ancho disponible para contenido

  var fechaOrden = new Date();
  // Obtiene los últimos dos dígitos del año actual
  var añoActual = fechaOrden.getFullYear().toString().slice(-2);
  const { dataEvento, dataProveedor, dataOrden, dataModulosOrden } = allDataOrdenPDF;

  // ==================================================================
  // ✨ INICIO DE LA CORRECCIÓN ORIGINAL ✨
  // ==================================================================

  // 1. Encuentra la orden correcta que corresponde al proveedor seleccionado
  // Se corrige dataProveedor.id por dataProveedor.proveedor para usar el ID correcto.
  const ordenCorrecta = dataOrden.find(o => o.orden_proveedor === dataProveedor.proveedor);
  if (!ordenCorrecta) {
    console.error("No se encontró la orden para el proveedor seleccionado. Verifique los datos:", { dataProveedor, dataOrden });
    swal("Error", "No se pudo encontrar la orden de compra para este proveedor.", "error");
    return;
  }

  // 2. Recalcula el total neto a partir de los módulos (detalles) que se mostrarán en el PDF
  let totalNetoRecalculado = 0;
  if (dataModulosOrden && dataModulosOrden.length > 0) {
    totalNetoRecalculado = dataModulosOrden.reduce((sum, modulo) => {
      // Asegurarse de que valor y cantidad sean números antes de multiplicar
      const valor = Number(modulo.valor) || 0;
      const cantidad = Number(modulo.cantidad) || 0;
      return sum + (valor * cantidad);
    }, 0);
  }

  // ==================================================================
  // ✨ FIN DE LA CORRECCIÓN ORIGINAL ✨
  // ==================================================================

  const branding = await cargarBrandingPDF();

  // Prepara los datos que se usarán para generar el PDF (usando la orden correcta)
  const dataToGenerate = {
    evento: {
      evento: dataEvento.nombre || "",
      encargado: dataEvento.encargado || "",
      fechaEnvioOC: ordenCorrecta.fOrdenCompra,
      fechaRealizacion: dataEvento.fPresupuesto || "",
      lugarRealizacion: dataEvento.direccion || "",
      tipoFactura: ordenCorrecta.tipoFactura || "",
    },
    proveedor: {
      señor: dataProveedor.nombre || "",
      direccion: dataProveedor.direccion || "",
      mail: dataProveedor.email || "",
      contacto: dataProveedor.contacto || "",
      rut: dataProveedor.rut || "",
      ciudad: dataProveedor.comuna || "",
      fono: dataProveedor.celular || "",
    },
    orden: {
      nOrden: `${ordenCorrecta.numero}`, // Usar el número de orden existente
      observaciones: ordenCorrecta.observaciones,
      formaPago: ordenCorrecta.formaPago,
      totalPagado: totalNetoRecalculado, // Usar el total recalculado
      tipoFactura: ordenCorrecta.tipoFactura,
    },
    modulosOrden: dataModulosOrden,
  };

  const { evento, proveedor, orden, modulosOrden } = dataToGenerate;

  // ==================================================================
  // ✨ INICIO DE NUEVAS CORRECCIONES ✨
  // ==================================================================
  
  // CORRECCIÓN 2: Se eliminan los decimales del IVA y del TOTAL FINAL.
  // Se utiliza Math.trunc() para cortar los decimales sin redondear.
  var totalNeto = normalizarMontoEntero(orden.totalPagado);
  var totalIva = orden.tipoFactura === "Exento" ? 0 : normalizarMontoEntero(totalNeto * 0.19);
  var totalEvento = orden.tipoFactura === "Exento" ? totalNeto : normalizarMontoEntero(totalNeto + totalIva);
  
  // ==================================================================
  // ✨ FIN DE NUEVAS CORRECCIONES ✨
  // ==================================================================

  // Define la estructura del cuerpo de la tabla principal de módulos/productos
  const bodyModulos = [
    [
      { text: "CANTIDAD", bold: true, fillColor: "#FFFFFF", color: "#243356", alignment: "center", fontSize: 9 },
      { text: "DETALLE", bold: true, fillColor: "#FFFFFF", color: "#243356", alignment: "center", fontSize: 9 },
      { text: "NETO", bold: true, fillColor: "#FFFFFF", color: "#243356", alignment: "center", fontSize: 9 }
    ]
  ];

  // Agrega cada módulo/producto a la tabla
  modulosOrden.forEach(function(modulo) {
    bodyModulos.push([
      { text: formatearMontoEntero(modulo.cantidad), alignment: "center", fontSize: 9 },
      { text: modulo.descripcion, fontSize: 9 },
      { text: formatearMontoEntero(modulo.valor), alignment: "right", fontSize: 9 }
    ]);
  });

  // Calcula el margen extra si hay pocos productos para mantener la estructura visual
  const rowsToShow = modulosOrden.length;
  const minRowsForEspacio = 8;
  let extraMargin = 0;
  if (rowsToShow < minRowsForEspacio) {
    extraMargin = (minRowsForEspacio - rowsToShow) * 26; // 26 puntos por fila para compensar
  }

  // Ancho fijo para la columna de los totales (Neto, IVA, Total) para una alineación precisa
  const netoColumnWidth = 110;

  // Definición completa del documento PDF utilizando pdfMake
  const docDefinition = {
    pageSize: { width: pageWidth, height: 792 }, // Tamaño de página Carta US (792 puntos de alto)
    header: function() {
      return crearHeaderPDF({
        branding,
        titulo: "ORDEN DE COMPRA",
        numero: orden.nOrden,
        fechaTexto: "",
        pageWidth,
        leftMargin,
        rightMargin,
      });
    },
    footer: crearFooterPDF({ branding, pageWidth, leftMargin, rightMargin }),
    pageMargins: [leftMargin, topMargin, rightMargin, bottomMargin], // Márgenes generales del contenido de la página
    content: [
      // Bloque de información del proveedor
      {
        columns: [
          // Columna izquierda: Señor(es), Dirección, Mail, Contacto
          [
            { text: [ { text: "Señor(es): ", bold: true }, proveedor.señor ], style: 'infoProv' },
            { text: [ { text: "Dirección: ", bold: true }, proveedor.direccion ], style: 'infoProv' },
            { text: [ { text: "Mail: ", bold: true }, proveedor.mail ], style: 'infoProv' },
            { text: [ { text: "Contacto: ", bold: true }, proveedor.contacto ], style: 'infoProv' }
          ],
          // Columna derecha: Rut, Ciudad, Fono - Alineación a la izquierda de la columna
          {
            width: netoColumnWidth, // Misma anchura que el bloque de totales para alineación
            stack: [
              { text: [ { text: "Rut: ", bold: true }, proveedor.rut ], alignment: 'left', style: 'infoProv' },
              { text: [ { text: "Ciudad: ", bold: true }, proveedor.ciudad ], alignment: 'left', style: 'infoProv' },
              { text: [ { text: "Fono: ", bold: true }, proveedor.fono ], alignment: 'left', style: 'infoProv' }
            ]
          }
        ],
        columnGap: 40, // Espacio entre las dos columnas principales
        margin: [0, 0, 0, 10]
      },
      { text: `RAZÓN SOCIAL: ${branding.razonSocial}${branding.rut ? ` - RUT: ${branding.rut}` : ""}`, bold: true, color: branding.colorPrimario, margin: [0, 4, 0, 2] },
      { canvas: [ { type: "line", x1: 0, y1: 0, x2: usableWidth, y2: 0, lineWidth: 3, lineColor: branding.colorSecundario } ], margin: [0, 8] },
      {
        columns: bloqueEmpresaPDF(branding, 'infoProv2')
      },
      { text: "LO SIGUIENTE", color: "#243356", bold: true, margin: [0, 8, 0, 2] },
      { canvas: [ { type: "line", x1: 0, y1: 0, x2: usableWidth, y2: 0, lineWidth: 3, lineColor: "#66ABCB" } ], margin: [0, 2, 0, 2] },
      // Tabla principal de productos/módulos
      {
        table: {
          headerRows: 1,
          // Anchos de las columnas: 60 para Cantidad, flexible para Detalle, 60 para Neto
          widths: [60, '*', 60],
          body: bodyModulos
        },
        layout: {
          fillColor: function(rowIndex) {
            return rowIndex === 0 ? "#FFFFFF" : (rowIndex % 2 ? "#F0F0F0" : "#FFFFFF");
          },
          hLineColor: function(i, node) {
            return (i === 1 || i === node.table.body.length) ? "#243356" : "#000000";
          },
          vLineColor: function() { return "#000000"; },
          hLineWidth: function(i) { return i === 0 ? 0.5 : 0.3; },
          vLineWidth: function() { return 0.3; }
        },
        margin: [0, 8, 0, 8 + extraMargin]
      },
      // BLOQUE DE TOTALES (NETO, IVA, TOTAL)
      {
        columns: [
          { width: '*', text: '' }, // Columna flexible para empujar los totales a la derecha
          {
            width: netoColumnWidth, // Ancho fijo para el bloque de totales (110 puntos)
            stack: [
              {
                table: {
                  widths: [55, 55], // Divide el espacio en dos celdas para el texto y el valor
                  body: [
                    [
                      { text: "NETO", bold: true, fontSize: 9, alignment: 'left', border: [false, false, false, false] },
                      { text: formatearMontoEntero(totalNeto), alignment: "right", fontSize: 9, border: [false, false, false, false] }
                    ]
                  ]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 0]
              },
              {
                canvas: [
                  { type: 'line', x1: 0, y1: 0, x2: netoColumnWidth, y2: 0, lineWidth: 1, lineColor: '#000' }
                ],
                margin: [0, 2, 0, 2]
              },
              {
                table: {
                  widths: [55, 55],
                  body: [
                    [
                      { text: "IVA", bold: true, fontSize: 9, alignment: 'left', border: [false, false, false, false] },
                      { text: formatearMontoEntero(totalIva), alignment: "right", fontSize: 9, border: [false, false, false, false] }
                    ]
                  ]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 0]
              },
              {
                table: {
                  widths: [55, 55],
                  body: [
                    [
                      { text: "TOTAL", bold: true, fontSize: 9, color: "#FFFFFF", fillColor: "#243356", alignment: "left", border: [false, false, false, false] },
                      { text: formatearMontoEntero(totalEvento), alignment: "right", fontSize: 9, color: "#FFFFFF", fillColor: "#243356", border: [false, false, false, false] }
                    ]
                  ]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 0]
              }
            ]
          }
        ],
        columnGap: 0,
        margin: [0, 0, 0, 0]
      },
      // Espacio en blanco y sección de detalles del evento y observaciones
      { text: " ", margin: [0, 5] },
      {
        columns: [
          [
            // { text: "EVENTO: " + evento.evento, style: "infoEvento" },
            // { text: "ENCARGADO: " + (evento.encargado || ""), style: "infoEvento" },
            // { text: "FECHA ENVIO OC: " + (evento.fechaEnvioOC ? new Date(evento.fechaEnvioOC).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : ""), style: "infoEvento" },
            // { text: "FECHA REALIZACION: " + (evento.fechaRealizacion ? new Date(evento.fechaRealizacion).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : ""), style: "infoEvento" },
            // { text: "LUGAR REALIZACION: " + evento.lugarRealizacion, style: "infoEvento" },

            { text: "OBSERVACIONES:", bold: true, color: "#243356", margin: [0, 8, 0, 0] },
            { canvas: [ { type: "line", x1: 0, y1: 0, x2: 190, y2: 0, lineWidth: 1, lineColor: "#66ABCB" } ] },
            { text: orden.observaciones || '', fontSize: 9, margin: [0, 8, 0, 0] }
          ],
          [
            {
              stack: [
                {
                  canvas: [
                    { type: 'line', x1: 0, y1: 0, x2: 120, y2: 0, lineWidth: 1, lineColor: '#000' }
                  ],
                  margin: [0, 40, 0, 0]
                },
                { text: usuario.nombre, style: "firma", margin: [0, 2, 0, 0] },
                { text: branding.razonSocial, style: "firma2" }
              ],
              alignment: 'right',
              margin: [0, 50, 0, 0]
            }
          ]
        ],
        columnGap: 10
      }
    ],
    styles: {
      tituloOC: { fontSize: 12, bold: true, color: "#243356" },
      numOC: { fontSize: 18, bold: true, color: "#66ABCB" },
      infoProv: { fontSize: 9, color: "#000" },
      infoProv2: { fontSize: 9, color: "#000", margin: [0, 0, 0, 1] },
      infoEvento: { fontSize: 10, margin: [0, 1, 0, 0] },
      firma: { fontSize: 10, bold: true, alignment: "right" },
      firma2: { fontSize: 10, alignment: "right" }
    },
    defaultStyle: {
      font: 'Roboto' // Asegúrate de que la fuente 'Roboto' esté cargada en pdfMake
    }
  };

  // Abre el PDF generado en una nueva pestaña
  pdfMake.createPdf(docDefinition).open();
};

  const fnPresupuestoPDF = async (evento) => {
    swal({
      title: "Su reporte se descargará en breve",
      icon: "success",
      dangerMode: true,
    });
    setIdCliente(evento.cliente_evento);
    setDataEvento(evento);
  };

  const fnGenerarPresupuesto = async () => {
    try {
      const evento = dataEvento;
      const cliente = datosCliente.data;
      const modulosEvento = modEnEvento;

      const fecha = new Date();
      const fechaFinal = `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`;
      const añoActual = fecha.getFullYear().toString().slice(-2);

      const branding = await cargarBrandingPDF();
      const numeroPresupuesto = obtenerNumeroPresupuesto(evento);

      // El total del presupuesto se calcula desde los módulos que se muestran en el PDF.
      // Antes se tomaba evento.totalCobrado; si ese dato estaba desactualizado o quedaba en 1,
      // el resumen final mostraba NETO/TOTAL como 1 aunque la tabla tuviera valores correctos.
      const totalNeto = obtenerTotalNetoPresupuesto(evento, modulosEvento);
      const totalIva = evento.tipoFact === "Exento" ? 0 : normalizarMontoEntero(totalNeto * 0.19);
      const totalEvento = evento.tipoFact === "Exento" ? totalNeto : normalizarMontoEntero(totalNeto + totalIva);

      const leftMargin = 60, rightMargin = 60, topMargin = 95, bottomMargin = 80;
      const pageWidth = 612;
      const usableWidth = pageWidth - leftMargin - rightMargin;

      const bodyModulos = [
        [
          { text: "CANTIDAD", bold: true, color: "#243356", alignment: "center", fontSize: 9 },
          { text: "DETALLE", bold: true, color: "#243356", alignment: "center", fontSize: 9 },
          { text: "NETO", bold: true, color: "#243356", alignment: "center", fontSize: 9 },
          { text: "TOTAL", bold: true, color: "#243356", alignment: "center", fontSize: 9 }
        ]
      ];

      modulosEvento.forEach(mod => {
        const valorModulo = normalizarMontoEntero(mod.valor);
        const cantidadModulo = Number(mod.cantidad) || 0;
        const rowTotal = normalizarMontoEntero(valorModulo * cantidadModulo);
        bodyModulos.push([
          { text: mod.cantidad.toString(), alignment: "center", fontSize: 9 },
          { text: mod.descripcion, alignment: "left", fontSize: 9 },
          { text: formatearMontoEntero(valorModulo), alignment: "right", fontSize: 9 },
          { text: formatearMontoEntero(rowTotal), alignment: "right", fontSize: 9 }
        ]);
      });

      // Definimos un ancho fijo para las columnas de información de cliente/empresa
      const infoColumnWidth = (usableWidth - 40) / 2; // 40 es el columnGap

      const docDefinition = {
        pageSize: { width: pageWidth, height: 792 },
        pageMargins: [leftMargin, topMargin, rightMargin, bottomMargin],
        header: crearHeaderPDF({
          branding,
          titulo: "PRESUPUESTO",
          numero: `${numeroPresupuesto}-${añoActual}`,
          fechaTexto: fechaFinal,
          pageWidth,
          leftMargin,
          rightMargin,
        }),
        footer: crearFooterPDF({ branding, pageWidth, leftMargin, rightMargin }),
        content: [
          {
            columns: [
              {
                width: infoColumnWidth,
                stack: [
                  { text: [{ text: "Señor(es): ", bold: true }, cliente.nombre], style: 'infoCliente' },
                  { text: [{ text: "Servicio: ", bold: true }, evento.servicio], style: 'infoCliente' },
                  { text: [{ text: "Ciudad: ", bold: true }, cliente.comuna], style: 'infoCliente' },
                  { text: [{ text: "Atención a: ", bold: true }, cliente.contacto], style: 'infoCliente' }
                ]
              },
              {
                width: infoColumnWidth,
                stack: [
                  { text: [{ text: "Mail: ", bold: true }, cliente.email], style: 'infoCliente' },
                  { text: [{ text: "Rut: ", bold: true }, cliente.rut], style: 'infoCliente' },
                  { text: [{ text: "CM: ", bold: true }, evento.cm], style: 'infoCliente' }
                ]
              }
            ],
            columnGap: 40,
            margin: [0, 0, 0, 10]
          },
          { text: `RAZÓN SOCIAL: ${branding.razonSocial}${branding.rut ? ` - RUT: ${branding.rut}` : ""}`, bold: true, color: branding.colorPrimario, margin: [0, 4, 0, 2] },
          { canvas: [{ type: "line", x1: 0, y1: 0, x2: usableWidth, y2: 0, lineWidth: 3, lineColor: branding.colorSecundario }], margin: [0, 8] },
          {
            columns: bloqueEmpresaPDF(branding, 'infoHatt'),
            columnGap: 40,
            margin: [0, 0, 0, 10]
          },
          { text: "LO SIGUIENTE", color: "#243356", bold: true, margin: [0, 8, 0, 2] },
          { canvas: [{ type: "line", x1: 0, y1: 0, x2: usableWidth, y2: 0, lineWidth: 3, lineColor: "#66ABCB" }], margin: [0, 2, 0, 2] },
          {
            table: {
              headerRows: 1,
              widths: [60, '*', 60, 60],
              body: bodyModulos
            },
            layout: {
              fillColor: function (rowIndex) {
                return rowIndex === 0 ? "#FFFFFF" : (rowIndex % 2 ? "#F0F0F0" : "#FFFFFF");
              },
              hLineColor: function (i, node) {
                return (i === 1 || i === node.table.body.length) ? "#243356" : "#000000";
              },
              vLineColor: function () { return "#000000"; },
              hLineWidth: function (i) { return i === 0 ? 0.5 : 0.3; },
              vLineWidth: function () { return 0.3; }
            },
            margin: [0, 8, 0, 8]
          },
          {
            columns: [
              {
                width: usableWidth / 2 - 20, // Mantener el ancho actual para la columna de "FORMA DE PAGO"
                stack: [
                  { text: "FORMA DE PAGO", bold: true, color: "#243356", fontSize: 9 },
                  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: usableWidth / 2 - 20, y2: 0, lineWidth: 1, lineColor: "#66ABCB" }] },
                  { text: evento.formaPago || '', fontSize: 9, alignment: 'justify' }
                ]
              },
              // Aquí es donde aplicamos el cambio
              {
                width: infoColumnWidth, // Usamos el mismo ancho que las columnas de información
                stack: [
                  {
                    table: {
                      widths: ['*', 70], // Esto es para las columnas dentro de la tabla de totales
                      body: [
                        ["NETO", { text: formatearMontoEntero(totalNeto), alignment: 'right' }],
                        ["IVA", { text: formatearMontoEntero(totalIva), alignment: 'right' }],
                        [
                          { text: "TOTAL", fillColor: "#243356", color: "#FFFFFF", bold: true },
                          { text: formatearMontoEntero(totalEvento), fillColor: "#243356", color: "#FFFFFF", alignment: 'right' }
                        ]
                      ]
                    },
                    layout: 'noBorders',
                    // Eliminamos el alignment 'right' del stack para que la tabla empiece a la izquierda de su columna
                    // y el margen derecho que podría estar empujándola.
                  }
                ]
              }
            ],
            columnGap: 40, // Mantener el mismo columnGap
            margin: [0, 15, 0, 0]
          },
          {
            columns: [
              {
                width: usableWidth / 2 - 20,
                stack: [
                  { text: "OBSERVACIONES:", bold: true, color: "#243356" },
                  { canvas: [{ type: "line", x1: 0, y1: 0, x2: usableWidth / 2 - 20, y2: 0, lineWidth: 1, lineColor: "#66ABCB" }] },
                  { text: evento.observacionCliente || '', fontSize: 9, alignment: 'justify' }
                ]
              },
              {
                width: usableWidth / 2,
                alignment: 'right',
                stack: [
                  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 120, y2: 0, lineWidth: 1, lineColor: '#000' }], margin: [0, 16, 0, 0] },
                  { text: usuario.nombre, style: "firma", margin: [0, 6, 0, 0] },
                  { text: branding.razonSocial, style: "firma2" }
                ]
              }
            ],
            columnGap: 20,
            margin: [0, 15, 0, 0]
          }
        ],
        styles: {
          fechaHeader: { fontSize: 12, color: "#000000" },
          tituloPresupuesto: { fontSize: 12, bold: true, color: "#243356" },
          numPresupuesto: { fontSize: 18, bold: true, color: "#66ABCB" },
          infoCliente: { fontSize: 9, color: "#000" },
          infoHatt: { fontSize: 9, color: "#000" },
          firma: { fontSize: 10, bold: true, alignment: "right" },
          firma2: { fontSize: 10, alignment: "right" }
        },
        defaultStyle: {
          font: 'Roboto'
        }
      };

      pdfMake.createPdf(docDefinition).open();

      cleanStatusModulosEvento();
      cleanGenerarPresupuesto();

    } catch (e) {
      swal({
        title: `Hubo un error, por favor intente nuevamente`,
        text: e.message || e,
        icon: "error",
        timer: 3000,
        button: false,
      });
      console.error(e);
    }
  };

  return (
    <ReporteContext.Provider
      value={{
        stOrdenCompraPDF: state.stOrdenCompraPDF,
        stPresupuestoPDF: state.stPresupuestoPDF,
        activarDescargaOrden: state.activarDescargaOrden,
        fnPresupuestoPDF,
        fnActivarInicioPDFOrden,
        fnDesactivarInicioPDFOrden,
        fnORdenPDF,
      }}
    >
      {props.children}
    </ReporteContext.Provider>
  );
};

export default ReporteState;
